/**
 * Middle School Complete Vocabulary - Grade 9 (九年级完整词汇)
 * 核心词汇约200个
 */

import { VocabularyWord } from './vocabulary';

export const grade9Vocabulary: VocabularyWord[] = [
  // F-H 高级词汇
  {
    id: 'fail', word: 'fail', phoneticUS: '/feɪl/', phoneticUK: '/feɪl/',
    meaning: '失败', example: 'Do not fail the test.', exampleTranslation: '不要考试不及格。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '❌'
  },
  {
    id: 'fair', word: 'fair', phoneticUS: '/fer/', phoneticUK: '/feə/',
    meaning: '公平的', example: 'Be fair to everyone.', exampleTranslation: '对每个人都公平。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '⚖️'
  },
  {
    id: 'fall', word: 'fall', phoneticUS: '/fɑl/', phoneticUK: '/fɔl/',
    meaning: '落下；秋天', example: 'Leaves fall in autumn.', exampleTranslation: '叶子在秋天落下。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🍂'
  },
  {
    id: 'false', word: 'false', phoneticUS: '/fɔls/', phoneticUK: '/fɔls/',
    meaning: '错误的', example: 'This is false.', exampleTranslation: '这是错误的。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '❌'
  },
  {
    id: 'famous', word: 'famous', phoneticUS: '/ˈfeɪməs/', phoneticUK: '/ˈfeɪməs/',
    meaning: '著名的', example: 'She is famous.', exampleTranslation: '她很著名。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '⭐'
  },
  {
    id: 'farm', word: 'farm', phoneticUS: '/fɑrm/', phoneticUK: '/fɑm/',
    meaning: '农场', example: 'My uncle has a farm.', exampleTranslation: '我叔叔有个农场。',
    category: 'places', difficulty: 'easy', grade: '9', level: 'middle', image: '🌾'
  },
  {
    id: 'farmer', word: 'farmer', phoneticUS: '/ˈfɑrmər/', phoneticUK: '/ˈfɑmə/',
    meaning: '农民', example: 'He is a farmer.', exampleTranslation: '他是农民。',
    category: 'jobs', difficulty: 'easy', grade: '9', level: 'middle', image: '👨‍🌾'
  },
  {
    id: 'fast', word: 'fast', phoneticUS: '/fæst/', phoneticUK: '/fæst/',
    meaning: '快的', example: 'He runs fast.', exampleTranslation: '他跑得快。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '⚡'
  },
  {
    id: 'fat', word: 'fat', phoneticUS: '/fæt/', phoneticUK: '/fæt/',
    meaning: '胖的', example: 'The cat is fat.', exampleTranslation: '猫很胖。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '🐱'
  },
  {
    id: 'father', word: 'father', phoneticUS: '/ˈfɑðər/', phoneticUK: '/ˈfɑðə/',
    meaning: '父亲', example: 'My father works hard.', exampleTranslation: '父亲工作努力。',
    category: 'family', difficulty: 'easy', grade: '9', level: 'middle', image: '👨'
  },
  {
    id: 'favor', word: 'favor', phoneticUS: '/ˈfeɪvər/', phoneticUK: '/ˈfeɪvə/',
    meaning: '恩惠；偏爱', example: 'Do me a favor.', exampleTranslation: '帮我一个忙。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🙏'
  },
  {
    id: 'favorite', word: 'favorite', phoneticUS: '/ˈfeɪvərɪt/', phoneticUK: '/ˈfeɪvərɪt/',
    meaning: '最喜欢的', example: 'My favorite color is blue.', exampleTranslation: '我最喜欢的颜色是蓝色。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '💙'
  },
  {
    id: 'fear', word: 'fear', phoneticUS: '/fɪr/', phoneticUK: '/fɪə/',
    meaning: '害怕', example: 'I have no fear.', exampleTranslation: '我不害怕。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '😨'
  },
  {
    id: 'feed', word: 'feed', phoneticUS: '/fiːd/', phoneticUK: '/fiːd/',
    meaning: '喂养', example: 'Feed the dog.', exampleTranslation: '喂狗。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🐕'
  },
  {
    id: 'feel', word: 'feel', phoneticUS: '/fiːl/', phoneticUK: '/fiːl/',
    meaning: '感觉', example: 'I feel happy.', exampleTranslation: '我感到快乐。',
    category: 'emotions', difficulty: 'easy', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'festival', word: 'festival', phoneticUS: '/ˈfestɪvəl/', phoneticUK: '/ˈfestɪvəl/',
    meaning: '节日', example: 'Spring Festival is important.', exampleTranslation: '春节很重要。',
    category: 'society', difficulty: 'easy', grade: '9', level: 'middle', image: '🎊'
  },
  {
    id: 'fetch', word: 'fetch', phoneticUS: '/fetʃ/', phoneticUK: '/fetʃ/',
    meaning: '取来', example: 'Fetch me a book.', exampleTranslation: '给我拿本书。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '📚'
  },
  {
    id: 'field', word: 'field', phoneticUS: '/fiːld/', phoneticUK: '/fiːld/',
    meaning: '田野；领域', example: 'Work in the field.', exampleTranslation: '在田野工作。',
    category: 'nature', difficulty: 'medium', grade: '9', level: 'middle', image: '🌾'
  },
  {
    id: 'fifteen', word: 'fifteen', phoneticUS: '/ˈfɪfˈtiːn/', phoneticUK: '/ˈfɪfˈtiːn/',
    meaning: '十五', example: 'I am fifteen years old.', exampleTranslation: '我15岁。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '1️⃣5️⃣'
  },
  {
    id: 'fifth', word: 'fifth', phoneticUS: '/fɪfθ/', phoneticUK: '/fɪfθ/',
    meaning: '第五', example: 'The fifth book.', exampleTranslation: '第五本书。',
    category: 'numbers', difficulty: 'medium', grade: '9', level: 'middle', image: '5️⃣'
  },
  {
    id: 'fifty', word: 'fifty', phoneticUS: '/ˈfɪfti/', phoneticUK: '/ˈfɪfti/',
    meaning: '五十', example: 'I have fifty books.', exampleTranslation: '我有50本书。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '5️⃣0️⃣'
  },
  {
    id: 'fight', word: 'fight', phoneticUS: '/faɪt/', phoneticUK: '/faɪt/',
    meaning: '打架；战斗', example: 'Do not fight.', exampleTranslation: '不要打架。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '⚔️'
  },
  {
    id: 'figure', word: 'figure', phoneticUS: '/ˈfɪɡjər/', phoneticUK: '/ˈfɪɡə/',
    meaning: '数字；人物', example: 'A famous figure.', exampleTranslation: '著名人物。',
    category: 'abstract', difficulty: 'hard', grade: '9', level: 'middle', image: '👤'
  },
  {
    id: 'fill', word: 'fill', phoneticUS: '/fɪl/', phoneticUK: '/fɪl/',
    meaning: '填充', example: 'Fill the bottle.', exampleTranslation: '装满瓶子。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🍶'
  },
  {
    id: 'film', word: 'film', phoneticUS: '/fɪlm/', phoneticUK: '/fɪlm/',
    meaning: '电影', example: 'Watch a film.', exampleTranslation: '看电影。',
    category: 'hobbies', difficulty: 'easy', grade: '9', level: 'middle', image: '🎬'
  },
  {
    id: 'final', word: 'final', phoneticUS: '/ˈfaɪnəl/', phoneticUK: '/ˈfaɪnəl/',
    meaning: '最后的', example: 'The final exam.', exampleTranslation: '期末考试。',
    category: 'time', difficulty: 'easy', grade: '9', level: 'middle', image: '🔚'
  },
  {
    id: 'find', word: 'find', phoneticUS: '/faɪnd/', phoneticUK: '/faɪnd/',
    meaning: '找到', example: 'Find your book.', exampleTranslation: '找到你的书。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🔍'
  },
  {
    id: 'fine', word: 'fine', phoneticUS: '/faɪn/', phoneticUK: '/faɪn/',
    meaning: '好的；罚款', example: 'I am fine.', exampleTranslation: '我很好。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'finish', word: 'finish', phoneticUS: '/ˈfɪnɪʃ/', phoneticUK: '/ˈfɪnɪʃ/',
    meaning: '完成', example: 'Finish your homework.', exampleTranslation: '完成作业。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '✅'
  },
  {
    id: 'fire', word: 'fire', phoneticUS: '/ˈfaɪər/', phoneticUK: '/ˈfaɪə/',
    meaning: '火', example: 'Fire is dangerous.', exampleTranslation: '火很危险。',
    category: 'nature', difficulty: 'easy', grade: '9', level: 'middle', image: '🔥'
  },
  {
    id: 'first', word: 'first', phoneticUS: '/fɜrst/', phoneticUK: '/fɜst/',
    meaning: '第一', example: 'First prize.', exampleTranslation: '一等奖。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '🥇'
  },
  {
    id: 'fish', word: 'fish', phoneticUS: '/fɪʃ/', phoneticUK: '/fɪʃ/',
    meaning: '鱼', example: 'I like fish.', exampleTranslation: '我喜欢鱼。',
    category: 'animals', difficulty: 'easy', grade: '9', level: 'middle', image: '🐟'
  },
  {
    id: 'fit', word: 'fit', phoneticUS: '/fɪt/', phoneticUK: '/fɪt/',
    meaning: '适合；健康的', example: 'This shirt fits me.', exampleTranslation: '这件衬衫适合我。',
    category: 'clothes', difficulty: 'medium', grade: '9', level: 'middle', image: '👕'
  },
  {
    id: 'five', word: 'five', phoneticUS: '/faɪv/', phoneticUK: '/faɪv/',
    meaning: '五', example: 'I have five books.', exampleTranslation: '我有5本书。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '5️⃣'
  },
  {
    id: 'fix', word: 'fix', phoneticUS: '/fɪks/', phoneticUK: '/fɪks/',
    meaning: '修理', example: 'Fix the bike.', exampleTranslation: '修自行车。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🔧'
  },
  {
    id: 'flag', word: 'flag', phoneticUS: '/flæg/', phoneticUK: '/flæg/',
    meaning: '旗帜', example: 'The flag is red.', exampleTranslation: '旗帜是红色的。',
    category: 'society', difficulty: 'easy', grade: '9', level: 'middle', image: '🚩'
  },
  {
    id: 'flat', word: 'flat', phoneticUS: '/flæt/', phoneticUK: '/flæt/',
    meaning: '平坦的；公寓', example: 'Live in a flat.', exampleTranslation: '住在公寓。',
    category: 'places', difficulty: 'medium', grade: '9', level: 'middle', image: '🏢'
  },
  {
    id: 'flight', word: 'flight', phoneticUS: '/flaɪt/', phoneticUK: '/flaɪt/',
    meaning: '航班', example: 'Take a flight.', exampleTranslation: '坐飞机。',
    category: 'travel', difficulty: 'medium', grade: '9', level: 'middle', image: '✈️'
  },
  {
    id: 'floor', word: 'floor', phoneticUS: '/flɔr/', phoneticUK: '/flɔ/',
    meaning: '地板', example: 'Clean the floor.', exampleTranslation: '打扫地板。',
    category: 'daily_life', difficulty: 'easy', grade: '9', level: 'middle', image: '🏠'
  },
  {
    id: 'flower', word: 'flower', phoneticUS: '/ˈflaʊər/', phoneticUK: '/ˈflaʊə/',
    meaning: '花', example: 'Beautiful flowers.', exampleTranslation: '美丽的花。',
    category: 'nature', difficulty: 'easy', grade: '9', level: 'middle', image: '🌸'
  },
  {
    id: 'fly', word: 'fly', phoneticUS: '/flaɪ/', phoneticUK: '/flaɪ/',
    meaning: '飞', example: 'Birds can fly.', exampleTranslation: '鸟会飞。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🦅'
  },
  {
    id: 'follow', word: 'follow', phoneticUS: '/ˈfɑloʊ/', phoneticUK: '/ˈfɒləʊ/',
    meaning: '跟随', example: 'Follow me.', exampleTranslation: '跟我来。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🚶'
  },
  {
    id: 'food', word: 'food', phoneticUS: '/fuːd/', phoneticUK: '/fuːd/',
    meaning: '食物', example: 'I like food.', exampleTranslation: '我喜欢食物。',
    category: 'food', difficulty: 'easy', grade: '9', level: 'middle', image: '🍽️'
  },
  {
    id: 'fool', word: 'fool', phoneticUS: '/fuːl/', phoneticUK: '/fuːl/',
    meaning: '傻瓜', example: 'Do not be a fool.', exampleTranslation: '不要当傻瓜。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🤪'
  },
  {
    id: 'foolish', word: 'foolish', phoneticUS: '/ˈfuːlɪʃ/', phoneticUK: '/ˈfuːlɪʃ/',
    meaning: '愚蠢的', example: 'That is foolish.', exampleTranslation: '那是愚蠢的。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🤪'
  },
  {
    id: 'foot', word: 'foot', phoneticUS: '/fʊt/', phoneticUK: '/fʊt/',
    meaning: '脚', example: 'I have two feet.', exampleTranslation: '我有两只脚。',
    category: 'body', difficulty: 'easy', grade: '9', level: 'middle', image: '🦶'
  },
  {
    id: 'football', word: 'football', phoneticUS: '/ˈfʊtbɔl/', phoneticUK: '/ˈfʊtbɔl/',
    meaning: '足球', example: 'Play football.', exampleTranslation: '踢足球。',
    category: 'sports', difficulty: 'easy', grade: '9', level: 'middle', image: '⚽'
  },
  {
    id: 'for', word: 'for', phoneticUS: '/fɔr/', phoneticUK: '/fɔ/',
    meaning: '为了', example: 'This is for you.', exampleTranslation: '这是给你的。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '🎁'
  },
  {
    id: 'force', word: 'force', phoneticUS: '/fɔrs/', phoneticUK: '/fɔs/',
    meaning: '力量；强迫', example: 'Use force.', exampleTranslation: '使用力量。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '💪'
  },
  {
    id: 'foreign', word: 'foreign', phoneticUS: '/ˈfɔrən/', phoneticUK: '/ˈfɒrən/',
    meaning: '外国的', example: 'Foreign language.', exampleTranslation: '外语。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🌍'
  },
  {
    id: 'forest', word: 'forest', phoneticUS: '/ˈfɔrɪst/', phoneticUK: '/ˈfɒrɪst/',
    meaning: '森林', example: 'The forest is big.', exampleTranslation: '森林很大。',
    category: 'nature', difficulty: 'medium', grade: '9', level: 'middle', image: '🌲'
  },
  {
    id: 'forget', word: 'forget', phoneticUS: '/fərˈɡet/', phoneticUK: '/fəˈɡet/',
    meaning: '忘记', example: 'Do not forget.', exampleTranslation: '不要忘记。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🧠'
  },
  {
    id: 'fork', word: 'fork', phoneticUS: '/fɔrk/', phoneticUK: '/fɔk/',
    meaning: '叉子', example: 'Use a fork.', exampleTranslation: '用叉子。',
    category: 'daily_life', difficulty: 'easy', grade: '9', level: 'middle', image: '🍴'
  },
  {
    id: 'form', word: 'form', phoneticUS: '/fɔrm/', phoneticUK: '/fɔm/',
    meaning: '形式；表格', example: 'Fill the form.', exampleTranslation: '填表格。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📋'
  },
  {
    id: 'forty', word: 'forty', phoneticUS: '/ˈfɔrti/', phoneticUK: '/ˈfɔti/',
    meaning: '四十', example: 'He is forty.', exampleTranslation: '他40岁。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '4️⃣0️⃣'
  },
  {
    id: 'forward', word: 'forward', phoneticUS: '/ˈfɔrwərd/', phoneticUK: '/ˈfɔwəd/',
    meaning: '向前', example: 'Move forward.', exampleTranslation: '向前走。',
    category: 'directions', difficulty: 'easy', grade: '9', level: 'middle', image: '➡️'
  },
  {
    id: 'found', word: 'found', phoneticUS: '/faʊnd/', phoneticUK: '/faʊnd/',
    meaning: '建立', example: 'Found a school.', exampleTranslation: '建立学校。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🏫'
  },
  {
    id: 'four', word: 'four', phoneticUS: '/fɔr/', phoneticUK: '/fɔ/',
    meaning: '四', example: 'I have four books.', exampleTranslation: '我有4本书。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '4️⃣'
  },
  {
    id: 'fourteen', word: 'fourteen', phoneticUS: '/ˈfɔrˈtiːn/', phoneticUK: '/ˈfɔˈtiːn/',
    meaning: '十四', example: 'She is fourteen.', exampleTranslation: '她14岁。',
    category: 'numbers', difficulty: 'easy', grade: '9', level: 'middle', image: '1️⃣4️⃣'
  },
  {
    id: 'fox', word: 'fox', phoneticUS: '/fɑks/', phoneticUK: '/fɒks/',
    meaning: '狐狸', example: 'The fox is clever.', exampleTranslation: '狐狸很聪明。',
    category: 'animals', difficulty: 'easy', grade: '9', level: 'middle', image: '🦊'
  },
  {
    id: 'free', word: 'free', phoneticUS: '/friː/', phoneticUK: '/friː/',
    meaning: '自由的；免费的', example: 'I am free.', exampleTranslation: '我有空。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '🕊️'
  },
  {
    id: 'freeze', word: 'freeze', phoneticUS: '/friːz/', phoneticUK: '/friːz/',
    meaning: '冻结', example: 'Water freezes.', exampleTranslation: '水结冰。',
    category: 'nature', difficulty: 'medium', grade: '9', level: 'middle', image: '❄️'
  },
  {
    id: 'fresh', word: 'fresh', phoneticUS: '/freʃ/', phoneticUK: '/freʃ/',
    meaning: '新鲜的', example: 'Fresh fruit.', exampleTranslation: '新鲜水果。',
    category: 'food', difficulty: 'easy', grade: '9', level: 'middle', image: '🍎'
  },
  {
    id: 'Friday', word: 'Friday', phoneticUS: '/ˈfraɪdeɪ/', phoneticUK: '/ˈfraɪdeɪ/',
    meaning: '星期五', example: 'Friday is my favorite.', exampleTranslation: '星期五是我最喜欢的。',
    category: 'time', difficulty: 'easy', grade: '9', level: 'middle', image: '📅'
  },
  {
    id: 'friend', word: 'friend', phoneticUS: '/frend/', phoneticUK: '/frend/',
    meaning: '朋友', example: 'My friend is kind.', exampleTranslation: '我的朋友很友善。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '👫'
  },
  {
    id: 'friendly', word: 'friendly', phoneticUS: '/ˈfrendli/', phoneticUK: '/ˈfrendli/',
    meaning: '友好的', example: 'He is friendly.', exampleTranslation: '他很友好。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'friendship', word: 'friendship', phoneticUS: '/ˈfrendʃɪp/', phoneticUK: '/ˈfrendʃɪp/',
    meaning: '友谊', example: 'Our friendship is strong.', exampleTranslation: '我们的友谊很牢固。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👫'
  },
  {
    id: 'from', word: 'from', phoneticUS: '/frɑm/', phoneticUK: '/frɒm/',
    meaning: '从...', example: 'I come from China.', exampleTranslation: '我来自中国。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '🇨🇳'
  },
  {
    id: 'front', word: 'front', phoneticUS: '/frʌnt/', phoneticUK: '/frʌnt/',
    meaning: '前面', example: 'Stand in front.', exampleTranslation: '站在前面。',
    category: 'directions', difficulty: 'easy', grade: '9', level: 'middle', image: '👆'
  },
  {
    id: 'fruit', word: 'fruit', phoneticUS: '/fruːt/', phoneticUK: '/fruːt/',
    meaning: '水果', example: 'I eat fruit.', exampleTranslation: '我吃水果。',
    category: 'food', difficulty: 'easy', grade: '9', level: 'middle', image: '🍎'
  },
  {
    id: 'full', word: 'full', phoneticUS: '/fʊl/', phoneticUK: '/fʊl/',
    meaning: '满的', example: 'The bottle is full.', exampleTranslation: '瓶子满了。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '🥤'
  },
  {
    id: 'fun', word: 'fun', phoneticUS: '/fʌn/', phoneticUK: '/fʌn/',
    meaning: '有趣的', example: 'Have fun!', exampleTranslation: '玩得开心！',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '🎉'
  },
  {
    id: 'funny', word: 'funny', phoneticUS: '/ˈfʌni/', phoneticUK: '/ˈfʌni/',
    meaning: '有趣的', example: 'The story is funny.', exampleTranslation: '故事很有趣。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '😂'
  },
  {
    id: 'future', word: 'future', phoneticUS: '/ˈfjuːtʃər/', phoneticUK: '/ˈfjuːtʃə/',
    meaning: '未来', example: 'In the future.', exampleTranslation: '在未来。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🔮'
  },

  // G-I 高级词汇
  {
    id: 'gain', word: 'gain', phoneticUS: '/ɡeɪn/', phoneticUK: '/ɡeɪn/',
    meaning: '获得', example: 'Gain knowledge.', exampleTranslation: '获得知识。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '📚'
  },
  {
    id: 'game', word: 'game', phoneticUS: '/ɡeɪm/', phoneticUK: '/ɡeɪm/',
    meaning: '游戏', example: 'Play a game.', exampleTranslation: '玩游戏。',
    category: 'hobbies', difficulty: 'easy', grade: '9', level: 'middle', image: '🎮'
  },
  {
    id: 'garden', word: 'garden', phoneticUS: '/ˈɡɑrdən/', phoneticUK: '/ˈɡɑdən/',
    meaning: '花园', example: 'A beautiful garden.', exampleTranslation: '美丽的花园。',
    category: 'nature', difficulty: 'easy', grade: '9', level: 'middle', image: '🌻'
  },
  {
    id: 'gate', word: 'gate', phoneticUS: '/ɡeɪt/', phoneticUK: '/ɡeɪt/',
    meaning: '大门', example: 'Open the gate.', exampleTranslation: '打开大门。',
    category: 'places', difficulty: 'easy', grade: '9', level: 'middle', image: '🚪'
  },
  {
    id: 'general', word: 'general', phoneticUS: '/ˈdʒenərəl/', phoneticUK: '/ˈdʒenərəl/',
    meaning: '一般的；将军', example: 'General idea.', exampleTranslation: '一般的想法。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '💡'
  },
  {
    id: 'gentle', word: 'gentle', phoneticUS: '/ˈdʒentəl/', phoneticUK: '/ˈdʒentəl/',
    meaning: '温柔的', example: 'Be gentle.', exampleTranslation: '温柔一点。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'gentleman', word: 'gentleman', phoneticUS: '/ˈdʒentlmən/', phoneticUK: '/ˈdʒentlmən/',
    meaning: '绅士', example: 'He is a gentleman.', exampleTranslation: '他是个绅士。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👔'
  },
  {
    id: 'get', word: 'get', phoneticUS: '/ɡet/', phoneticUK: '/ɡet/',
    meaning: '得到', example: 'Get a book.', exampleTranslation: '拿一本书。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '📚'
  },
  {
    id: 'gift', word: 'gift', phoneticUS: '/ɡɪft/', phoneticUK: '/ɡɪft/',
    meaning: '礼物', example: 'Give a gift.', exampleTranslation: '送礼物。',
    category: 'daily_life', difficulty: 'easy', grade: '9', level: 'middle', image: '🎁'
  },
  {
    id: 'girl', word: 'girl', phoneticUS: '/ɡɜrl/', phoneticUK: '/ɡɜl/',
    meaning: '女孩', example: 'She is a girl.', exampleTranslation: '她是女孩。',
    category: 'family', difficulty: 'easy', grade: '9', level: 'middle', image: '👧'
  },
  {
    id: 'give', word: 'give', phoneticUS: '/ɡɪv/', phoneticUK: '/ɡɪv/',
    meaning: '给', example: 'Give me a pen.', exampleTranslation: '给我一支笔。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🎁'
  },
  {
    id: 'glad', word: 'glad', phoneticUS: '/ɡlæd/', phoneticUK: '/ɡlæd/',
    meaning: '高兴的', example: 'I am glad.', exampleTranslation: '我很高兴。',
    category: 'emotions', difficulty: 'easy', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'glass', word: 'glass', phoneticUS: '/ɡlæs/', phoneticUK: '/ɡlæs/',
    meaning: '玻璃；杯子', example: 'A glass of water.', exampleTranslation: '一杯水。',
    category: 'daily_life', difficulty: 'easy', grade: '9', level: 'middle', image: '🥛'
  },
  {
    id: 'glove', word: 'glove', phoneticUS: '/ɡlʌv/', phoneticUK: '/ɡlʌv/',
    meaning: '手套', example: 'Wear gloves.', exampleTranslation: '戴手套。',
    category: 'clothes', difficulty: 'easy', grade: '9', level: 'middle', image: '🧤'
  },
  {
    id: 'go', word: 'go', phoneticUS: '/ɡoʊ/', phoneticUK: '/ɡəʊ/',
    meaning: '去', example: 'Go to school.', exampleTranslation: '去学校。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🚶'
  },
  {
    id: 'goal', word: 'goal', phoneticUS: '/ɡoʊl/', phoneticUK: '/ɡəʊl/',
    meaning: '目标', example: 'Reach your goal.', exampleTranslation: '达到目标。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🎯'
  },
  {
    id: 'gold', word: 'gold', phoneticUS: '/ɡoʊld/', phoneticUK: '/ɡəʊld/',
    meaning: '金子', example: 'Gold is expensive.', exampleTranslation: '金子很贵。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🥇'
  },
  {
    id: 'golden', word: 'golden', phoneticUS: '/ˈɡoʊldən/', phoneticUK: '/ˈɡəʊldən/',
    meaning: '金色的', example: 'Golden hair.', exampleTranslation: '金色的头发。',
    category: 'colors', difficulty: 'medium', grade: '9', level: 'middle', image: '✨'
  },
  {
    id: 'good', word: 'good', phoneticUS: '/ɡʊd/', phoneticUK: '/ɡʊd/',
    meaning: '好的', example: 'Good morning!', exampleTranslation: '早上好！',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '👍'
  },
  {
    id: 'goodbye', word: 'goodbye', phoneticUS: '/ɡʊdˈbaɪ/', phoneticUK: '/ɡʊdˈbaɪ/',
    meaning: '再见', example: 'Say goodbye.', exampleTranslation: '说再见。',
    category: 'daily_life', difficulty: 'easy', grade: '9', level: 'middle', image: '👋'
  },
  {
    id: 'government', word: 'government', phoneticUS: '/ˈɡʌvərnəmənt/', phoneticUK: '/ˈɡʌvərnəmənt/',
    meaning: '政府', example: 'The government works hard.', exampleTranslation: '政府工作努力。',
    category: 'society', difficulty: 'hard', grade: '9', level: 'middle', image: '🏛️'
  },
  {
    id: 'grade', word: 'grade', phoneticUS: '/ɡreɪd/', phoneticUK: '/ɡreɪd/',
    meaning: '年级；成绩', example: 'I am in Grade 9.', exampleTranslation: '我在9年级。',
    category: 'school', difficulty: 'easy', grade: '9', level: 'middle', image: '📚'
  },
  {
    id: 'grass', word: 'grass', phoneticUS: '/ɡræs/', phoneticUK: '/ɡræs/',
    meaning: '草', example: 'Green grass.', exampleTranslation: '绿色的草。',
    category: 'nature', difficulty: 'easy', grade: '9', level: 'middle', image: '🌿'
  },
  {
    id: 'great', word: 'great', phoneticUS: '/ɡreɪt/', phoneticUK: '/ɡreɪt/',
    meaning: '伟大的', example: 'Great idea!', exampleTranslation: '好主意！',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '⭐'
  },
  {
    id: 'green', word: 'green', phoneticUS: '/ɡriːn/', phoneticUK: '/ɡriːn/',
    meaning: '绿色', example: 'Green trees.', exampleTranslation: '绿色的树。',
    category: 'colors', difficulty: 'easy', grade: '9', level: 'middle', image: '🟢'
  },
  {
    id: 'ground', word: 'ground', phoneticUS: '/ɡraʊnd/', phoneticUK: '/ɡraʊnd/',
    meaning: '地面', example: 'Sit on the ground.', exampleTranslation: '坐在地上。',
    category: 'nature', difficulty: 'easy', grade: '9', level: 'middle', image: '🌍'
  },
  {
    id: 'group', word: 'group', phoneticUS: '/ɡruːp/', phoneticUK: '/ɡruːp/',
    meaning: '组；群', example: 'Study in a group.', exampleTranslation: '小组学习。',
    category: 'abstract', difficulty: 'easy', grade: '9', level: 'middle', image: '👥'
  },
  {
    id: 'grow', word: 'grow', phoneticUS: '/ɡroʊ/', phoneticUK: '/ɡrəʊ/',
    meaning: '生长', example: 'Plants grow.', exampleTranslation: '植物生长。',
    category: 'nature', difficulty: 'easy', grade: '9', level: 'middle', image: '🌱'
  },
  {
    id: 'growth', word: 'growth', phoneticUS: '/ɡroʊθ/', phoneticUK: '/ɡrəʊθ/',
    meaning: '生长', example: 'Economic growth.', exampleTranslation: '经济增长。',
    category: 'abstract', difficulty: 'hard', grade: '9', level: 'middle', image: '📈'
  },
  {
    id: 'guard', word: 'guard', phoneticUS: '/ɡɑrd/', phoneticUK: '/ɡɑd/',
    meaning: '守卫', example: 'Guard the door.', exampleTranslation: '守门。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '💂'
  },
  {
    id: 'guess', word: 'guess', phoneticUS: '/ɡes/', phoneticUK: '/ɡes/',
    meaning: '猜测', example: 'Guess the answer.', exampleTranslation: '猜答案。',
    category: 'actions', difficulty: 'easy', grade: '9', level: 'middle', image: '🤔'
  },
  {
    id: 'guest', word: 'guest', phoneticUS: '/ɡest/', phoneticUK: '/ɡest/',
    meaning: '客人', example: 'Welcome the guest.', exampleTranslation: '欢迎客人。',
    category: 'daily_life', difficulty: 'easy', grade: '9', level: 'middle', image: '👋'
  },
  {
    id: 'guide', word: 'guide', phoneticUS: '/ɡaɪd/', phoneticUK: '/ɡaɪd/',
    meaning: '向导；指导', example: 'A tour guide.', exampleTranslation: '导游。',
    category: 'jobs', difficulty: 'medium', grade: '9', level: 'middle', image: '🗺️'
  },
  {
    id: 'guitar', word: 'guitar', phoneticUS: '/ɡɪˈtɑr/', phoneticUK: '/ɡɪˈtɑ/',
    meaning: '吉他', example: 'Play the guitar.', exampleTranslation: '弹吉他。',
    category: 'hobbies', difficulty: 'easy', grade: '9', level: 'middle', image: '🎸'
  },
];

export default grade9Vocabulary;